import { defineComponent as _defineComponent } from 'vue'
import CustomerCare from '../shared/CustomerCare.vue';
import FooterQuickLinks from '../shared/FooterQuickLinks.vue';
import MobileFooterLinks from './MobileFooterLinks.vue';
import SignUpSection from '../shared/SignUpSection.vue';
import StoreSummaryMobile from '../StoreSummaryMobile.vue';
import { ILocalStoreJson } from 'JS/types/LocalStore';



export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFooter',
  props: {
    store: null
  },
  setup(__props: any) {

const props = __props as {
	store: ILocalStoreJson
}




return { __sfc: true,props, CustomerCare, FooterQuickLinks, MobileFooterLinks, SignUpSection, StoreSummaryMobile }
}

})